import { render, staticRenderFns } from "./SubjectDetail6.vue?vue&type=template&id=6de03e94&scoped=true&"
import script from "./SubjectDetail6.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail6.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail6.vue?vue&type=style&index=0&id=6de03e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de03e94",
  null
  
)

export default component.exports